import AddToCollection from './add-to-collection';

export default AddToCollection;
